import { useState } from 'react';
//widgets
import withStyles from '@material-ui/core/styles/withStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
//icons
import CloseIcon from '@material-ui/icons/Close';
//local
import MessageBG from '../../assets/img/messagebg.jpg';
import ThumbsUp from '../../assets/img/ThumbsUp.png';
import ThumbsDown from '../../assets/img/ThumbsDown.png';
import { useImage } from '../../hooks/useImage';

const MessageView = (props) => {
  const { classes, portal, open, close, message, controls, controlStyles } =
    props;
  const [preview, setPreview] = useState(false);
  const { getImage, image } = useImage();

  const closePreview = () => {
    setPreview(false);
  };

  const randomNumber = Math.random().toString(36).substr(2, 5);

  return (
    <Dialog
      aria-label={message.subject}
      open={open}
      onFocus={() =>
        message.isImage && message.image.name && !message.image.url
          ? getImage(message.image.name)
          : null
      }
      onClose={close}
      classes={{ paper: classes.maxWidth }}
    >
      <div
        className={`${classes.message} ${
          message.isImage ? classes.imageMsg : classes.textMsg
        }`}
      >
        {message.isImage ? (
          <img src={image ?? message.image.url} alt={message.subject} />
        ) : (
          <div>
            <div className={classes.title}>{message.subject}</div>
            <div className={classes.body}>{message.body}</div>
            <div className={classes.footer}>{message.footer}</div>
          </div>
        )}
        <div
          className={`${classes.buttons} ${
            message.isImage ? classes.buttonsImg : classes.buttonsText
          }`}
        >
          {message.buttons
            ? message.buttons.map((button, key) => (
                <button
                  key={key}
                  className={`${classes.button} ${
                    button.text === '👍'
                      ? classes.thumbupBtn
                      : button.text === '👎'
                      ? classes.thumbdownBtn
                      : classes.otherBtn
                  }`}
                  onClick={() => setPreview(button)}
                >
                  {button.text === '👍' || button.text === '👎'
                    ? ''
                    : button.text}
                </button>
              ))
            : null}
          <button
            className={`${classes.button} ${classes.dismissBtn}`}
            onClick={close}
          >
            Dismiss
          </button>
        </div>
        <Dialog
          onClose={closePreview}
          onFocus={() =>
            preview && preview.image.name && !preview.image.url
              ? getImage(preview.image.name)
              : null
          }
          aria-labelledby={'preview' + randomNumber}
          open={Boolean(preview)}
        >
          <DialogTitle
            id={'preview' + randomNumber}
            className={classes.previewTitle}
          >
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>{preview ? preview.text : ''}</Grid>
              <Grid item>
                <IconButton aria-label="Close" onClick={closePreview}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>
          {preview && preview.image.url ? (
            <img
              className={classes.imgFluid}
              src={preview.image.url}
              alt={preview.image.name}
            />
          ) : (
            <div className={classes.imgFluid} />
          )}
        </Dialog>
      </div>
      {controls ? <div className={controlStyles}>{controls}</div> : null}
    </Dialog>
  );
};

const styles = () => ({
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  maxWidth: {
    maxWidth: '624px',
  },
  message: {
    overflow: 'hidden',
    boxShadow:
      '0 14px 26px -12px rgba(153, 153, 153, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(153, 153, 153, 0.2)',
    textAlign: 'center',
    backgroundImage: 'url(' + MessageBG + ')',
    backgroundSize: 'cover',
    position: 'relative',
  },
  textMsg: {
    height: '254px',
    width: '490px',
    fontFamily: 'Segoe UI Bold',
    color: 'black',
  },
  imageMsg: {
    height: '400px',
    width: '624px',
    paddingTop: '10px',
  },
  title: {
    position: 'absolute',
    top: '10px',
    left: '-52px',
    width: '600px',
    fontSize: '32px',
    lineHeight: '1.3em',
  },
  body: {
    fontFamily: 'Segoe UI SemiBold',
    position: 'absolute',
    top: '50px',
    left: '3px',
    height: '300px',
    width: '480px',
    fontSize: '28px',
    lineHeight: '1.3em',
  },
  footer: {
    position: 'absolute',
    top: '131px',
    left: '3px',
    height: '300px',
    width: '480px',
    fontSize: '26px',
    lineHeight: '1.3em',
  },
  buttons: {
    position: 'absolute',
    width: '100%',
    display: 'flex',
    alignContent: 'flex-start',
    justifyContent: 'center',
  },
  buttonsImg: {
    top: '335px',
  },
  buttonsText: {
    top: '195px',
  },
  button: {
    fontFamily: 'Segoe UI Bold',
    fontSize: '22px',
    color: '#fff',
    cursor: 'pointer',
    marginLeft: '9px',
    marginRight: '9px',
    width: '110px',
    height: '50px',
    padding: 0,
    border: '2px solid #666',
    backgroundSize: 'cover',
  },
  dismissBtn: {
    backgroundColor: '#0053a9',
    border: '2px solid #fff',
  },
  thumbupBtn: {
    backgroundImage: 'url(' + ThumbsUp + ')',
  },
  thumbdownBtn: {
    backgroundImage: 'url(' + ThumbsDown + ')',
  },
  otherBtn: {
    backgroundColor: '#666',
  },
  imgFluid: {
    maxWidth: '100%',
    height: 'auto',
    minWidth: 200,
    minHeight: 200,
  },
  previewTitle: {
    borderBottom: '1px solid #ccc',
    padding: '0px 24px',
  },
});

export default withStyles(styles)(MessageView);
